import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/da-ne-kamera.png'


const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "card-text"
}
const _hoisted_5 = { class: "subject" }
const _hoisted_6 = { class: "table table-hover" }
const _hoisted_7 = {
  key: 1,
  class: "card-text"
}
const _hoisted_8 = { class: "btn-group float-end" }
const _hoisted_9 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "card-img"
  })
], -1)
const _hoisted_12 = { class: "card mb-3" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "card-text" }
const _hoisted_16 = { class: "card mb-3" }
const _hoisted_17 = { class: "card-header" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-triangle-exclamation" }, null, -1)
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "card-text" }

import Layout from '@/components/Layout.vue';
import Navigation from '@/components/Navigation.vue';
import Test from '@/components/Test.vue';
import {SubjectModel} from '@/models/subject.model';
import {TestModel} from '@/models/test.model';
import {MainService} from '@/services/main.service';
import {onBeforeMount, onBeforeUnmount, ref} from 'vue';
import {useRouter} from 'vue-router';
import {useHasActiveTest} from "@/hooks/hastest.hook";
import {AlertManager} from "@/services/alert.manager";
import {useTranslate} from "@/hooks/translate.hook";
import Swal from 'sweetalert2';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListView',
  setup(__props) {

const subjects = ref<SubjectModel[]>([])
const hasTest = useHasActiveTest()
const t = useTranslate()
let fatalShown = false

function loadAvailableTests() {
  MainService.getAvailableTests().then(rsp => {
    subjects.value = rsp.data
  }).catch(e => {
    if (e.message == 'BACKEND_UNREACHABLE' && !fatalShown) {
      fatalShown = true
      AlertManager.fatal(t('error.backend'))
    }
  })
}

const selectedTest = ref<TestModel>()

function selectTest(test: TestModel) {
  selectedTest.value = test
}

const router = useRouter()

function startTest() {
  if (selectedTest.value == undefined) return
  AlertManager.confirm(
      t("page.list.test.alert.title"),
      t("page.list.test.alert.desc") + selectedTest.value.title,
      t("page.list.test.alert.yes"),
      t("page.list.test.alert.no"),
      async () => {
        AlertManager.showLoading()

        // Camera check
        const cam = await hasCameraAccess()
        const mand = selectedTest.value!.requireCamera
        if (!mand || (mand && cam)) {
          MainService.startStudentTest(selectedTest.value!.testId).then(rsp => {
            router.push({
              path: '/test'
            })
            Swal.close()
          }).catch(e => {
            Swal.close()
            AlertManager.error(t(e.message).startsWith("error.") ? t('error.start') : t("error." + e.message))
          })
          return
        }

        // No camera found
        await Swal.close()
        AlertManager.error(t('error.camera'))
      })
}

async function hasCameraAccess(): Promise<boolean> {
  try {
    // Try to access the user's camera
    await navigator.mediaDevices.getUserMedia({video: true});

    // If successful, the user has allowed camera access
    return true;
  } catch (error) {
    // If there is an error, the user has not allowed camera access
    return false;
  }
}

onBeforeMount(() => {
  hasTest()
  loadAvailableTests()
})

// auto update data every 15 sec
const interval = setInterval(loadAvailableTests, 15000)
onBeforeUnmount(() => clearInterval(interval));

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)("page.list.test.title")), 1),
          _createElementVNode("div", _hoisted_3, [
            (Object.keys(subjects.value).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjects.value, (subject) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h6", null, _toDisplayString(subject.title), 1),
                      _createElementVNode("table", _hoisted_6, [
                        _createElementVNode("tbody", {
                          ref_for: true,
                          ref: "tbody"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subject.tests, (test) => {
                            return (_openBlock(), _createBlock(Test, {
                              test: test,
                              selected: test.testId == selectedTest.value?.testId,
                              onClick: ($event: any) => (selectTest(test))
                            }, null, 8, ["test", "selected", "onClick"]))
                          }), 256))
                        ], 512)
                      ])
                    ]))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)("page.list.test.fallback")), 1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (loadAvailableTests()))
              }, _toDisplayString(_unref(t)("page.list.test.refresh")), 1),
              (selectedTest.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startTest()))
                  }, _toDisplayString(_unref(t)("page.list.test.start")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (selectedTest.value?.requireCamera)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(t)("page.list.camera.title")), 1),
              _hoisted_11
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(t)("page.list.setup.title")), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, [
              _createVNode(_component_RouterLink, {
                to: "/setup",
                class: "fw-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("page.list.setup.click")), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("page.list.setup.text")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h5", _hoisted_17, [
            _hoisted_18,
            _createTextVNode(" " + _toDisplayString(_unref(t)("page.list.note.title")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)("page.list.note.text")), 1),
            _createElementVNode("ol", null, [
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.0`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.1`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.2`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.3`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.4`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.5`)), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)(`page.list.note.rules.6`)), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})